import { CompanyGet, CompanyStatus } from "@kase/my-marathon-communication";
import { computed } from "@preact/signals";
import { ApiSliceParams } from "../interfaces";
import { createListController } from "../utils";
import { Company } from "./interfaces";

const PROD_STATUSES = [CompanyStatus.Production, CompanyStatus.Unknown];

export const makeCompany = ({ connection }: ApiSliceParams) => {
    const {
        items,
        allLoaded: loaded,
        allLoading: loading,
        listen,
    } = createListController<CompanyGet, Company>({
        connection,
        list: (con) => con.company.items(),
    });
    const active = computed(() =>
        items.value.filter((c) => c.active && PROD_STATUSES.includes(c.status)),
    );
    const approve = computed(() =>
        items.value.filter(
            (c) =>
                c.active &&
                PROD_STATUSES.includes(c.status) &&
                (c.module_bok || c.module_lev),
        ),
    );

    const getByCode = (code: string | null | undefined) => {
        if (!code) {
            return null;
        }

        return items.peek().find((c) => c.code === code) ?? null;
    };

    return {
        items,
        active,
        approve,
        loaded,
        loading,
        listen,
        getByCode,
    };
};
